import './App.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {useState} from "react";
import Bio from "./Bio";
import Schedule from "./Schedule";
import Contact from "./Contact";
import Footer from "./Footer";

function App() {

    const [showBio, setShowBio] = useState(false);
    const [showSchedule, setShowSchedule] = useState(true);
    const [showContact, setShowContact] = useState(false);

    const navBio = () => {
        setShowBio(true);
        setShowSchedule(false);
        setShowContact(false);
    }

    const navSchedule = () => {
        setShowBio(false);
        setShowSchedule(true);
        setShowContact(false);
    }

    const navContact = () => {
        setShowBio(false);
        setShowSchedule(false);
        setShowContact(true);
    }

    return (
        <>
        <div className="App">
          <Navbar expand="lg" className="bg-body-tertiary" variant={"dark"}>
              <Container>
                  <Navbar.Brand href="#home">
                      <img
                          src={require('./resources/img/daveface.jpg')}
                          className="d-inline-block align-top"
                          alt="Daves Face"
                          height={75}
                          width={75}
                      />
                  </Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                      <Nav className="me-auto">
                          <Nav.Link onClick={()=>navSchedule()} href="#schedule">Schedule</Nav.Link>
                          <Nav.Link onClick={()=>navBio()} href="#bio">Bio</Nav.Link>
                          <Nav.Link onClick={()=>navContact()} href="#contact">Contact</Nav.Link>
                          <NavDropdown title="Socials" id="socia-media-dropdown">
                              <NavDropdown.Item target="_blank" href="https://www.instagram.com/dj.greekgod/?hl=en">Instagram</NavDropdown.Item>
                              <NavDropdown.Item target="_blank" href="https://www.facebook.com/cactusfacedave">Facebook</NavDropdown.Item>
                              <NavDropdown.Item target="_blank" href="https://www.youtube.com/@djgreekgod">YouTube</NavDropdown.Item>
                          </NavDropdown>
                      </Nav>
                  </Navbar.Collapse>
              </Container>
          </Navbar>
            <div>
                <>
                    {
                        showBio ?
                            <Bio /> : null
                    }
                </>
                <>
                    {
                        showSchedule ?
                            <Schedule /> : null
                    }
                </>
                <>
                    {
                        showContact ?
                            <Contact /> : null
                    }
                </>
            </div>
        </div>
        <Footer />
        </>
    );
}

export default App;
